module.exports = __webpack_public_path__ + "img/iguacu-falls.b3815ddc.jpg";